module.exports = __webpack_public_path__ + "static/media/bg.3e040b02.svg";